module.exports = __webpack_public_path__ + "static/media/aim-twl-logo-black.77582c04.png";